import { ref, computed } from 'vue'
import { createGlobalState } from '@vueuse/core'

export const useServiceStatus = createGlobalState(() => {
  const unavailableServices = ref<Set<string>>(new Set())

  const addUnavailableService = (serviceName: string) => {
    unavailableServices.value.add(serviceName)
  }

  const hasUnavailableServices = computed(() => unavailableServices.value.size > 0)

  const unavailableServicesList = computed(() => Array.from(unavailableServices.value))

  return {
    addUnavailableService,
    hasUnavailableServices,
    unavailableServicesList
  }
})
